const variables = {
	font_family_th: '"Helvetica Neue", Helvetica, Arial, sans-serif',
	font_family_en: '"Roboto", sans-serif',

	c_white: "#ffffff",
	font_color: "#656d7d",
	font_title_color: "#1c2f48",
	font_title_weight: "500",
	spd_blue: "#3e97d3",
	bg_gray: "#f3f5f7",

	// screen_sm: '540px',

	screen_xs_max: "539px",
	screen_sm_max: "767px",
	screen_md_max: "991.98px",

	screen_lg: "1200px",
	screen_md: "992px",
	screen_sm: "768px",
};

export const THAI = variables.font_family_th;

export default variables;



// WEBPACK FOOTER //
// ./src/components/style/variables.jsx